export default "__VITE_ASSET__DYLkfKrJ__"